import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import React from "react";

interface SnackbarState {
  isOpen: boolean;
  message: string;
  icon?: React.ReactNode;
  buttonText?: string;
  type?: "success" | "error";
  autoCloseDuration?: number | null;

  // Blocking snackbar state
  isBlockingOpen: boolean;
  blockingCountdown: number;
}

const initialState: SnackbarState = {
  isOpen: false,
  message: "",
  icon: undefined,
  buttonText: "",
  type: "success",
  autoCloseDuration: 3000,

  isBlockingOpen: false,
  blockingCountdown: 5,
};

const blockingSnackbarSlice = createSlice({
  name: "blockingSnackbar",
  initialState,
  reducers: {
    showSnackbar: (
      state,
      action: PayloadAction<{
        message: string;
        icon?: React.ReactNode;
        buttonText?: string;
        type?: "success" | "error";
        autoCloseDuration?: number | null;
      }>
    ) => {
      state.isOpen = true;
      state.message = action.payload.message;
      state.icon = action.payload.icon;
      state.buttonText = action.payload.buttonText;
      state.type = action.payload.type || "success";
      state.autoCloseDuration =
        action.payload.autoCloseDuration === undefined
          ? 3000
          : action.payload.autoCloseDuration;
    },
    hideSnackbar: (state) => {
      state.isOpen = false;
      state.message = "";
      state.icon = undefined;
      state.buttonText = "";
      state.type = "success";
      state.autoCloseDuration = 3000;
    },
    showBlockingSnackbar: (
      state,
      action: PayloadAction<{ countdown: number }>
    ) => {
      state.isBlockingOpen = true;
      state.blockingCountdown = action.payload.countdown;
    },
    decrementBlockingCountdown: (state) => {
      if (state.blockingCountdown > 0) {
        state.blockingCountdown -= 1;
      }
    },
    hideBlockingSnackbar: (state) => {
      state.isBlockingOpen = false;
      state.blockingCountdown = 5;
    },
  },
});

export const {
  showSnackbar,
  hideSnackbar,
  showBlockingSnackbar,
  decrementBlockingCountdown,
  hideBlockingSnackbar,
} = blockingSnackbarSlice.actions;

export default blockingSnackbarSlice.reducer;
